// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","480":"90b75d2b","491":"5227ff75","601":"e5b48792","995":"ee73ee9e"}[chunkId] + ".js";
};